// extracted by mini-css-extract-plugin
export var container = "_gm-0";
export var infoIcon = "_gm-2";
export var titleRowCol = "_gm-1";